import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Dialog, { DialogContent, DialogTop } from '@/components/Dialog';
import Spinner from '@/components/Spinner';
import { getPaymentModule } from '@/components/payment/getPaymentModule';
import { PAYMENT_HANDLER } from '@/config';
import { useShallowEqualSelector } from '@/hooks';
import { fetchBillingInfo } from '@/store/profile/thunks';
import { showError } from '@/utils';

const { PaymentElement } = getPaymentModule(PAYMENT_HANDLER);

function UpdatePaymentMethod({ open, onOpenChange, update }) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { ready, reactivate, currency, priceCurrency } =
		useShallowEqualSelector(state => ({
			ready: state.profile.billingInfoReady,
			reactivate: state.billing.reactivate,
			plan: state.profile.subscriptionInfo?.plan,
			handlerPriceId: state.profile.subscriptionInfo?.handlerPriceId,
			currency: state.profile?.currency,
			priceCurrency: state.profile?.priceCurrency
		}));

	const loadingRender = (
		<div className="flex min-h-32 justify-center pt-6">
			<Spinner />
		</div>
	);

	async function onSavedPaymentMethod() {
		// TODO: review if reactivate validation is necessary
		if (!reactivate) {
			await dispatch(fetchBillingInfo()).unwrap();

			return onOpenChange(false);
		}
	}

	async function handleSetupErr() {
		showError(t('errors.generic'));

		return onOpenChange(false);
	}

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent
				className="w-[calc(100vw-40px)] max-w-[606px]"
				onInteractOutside={evt => {
					if (evt?.target?.tagName?.toLowerCase() === 'apple-pay-modal') {
						evt.preventDefault();
					}
				}}
			>
				<DialogTop
					title={
						update
							? t('billing.modals.updatePaymentMethod')
							: t('billing.modals.addPaymentMethod')
					}
					description={
						update
							? t('billing.modals.updatePaymentMethod')
							: t('billing.modals.addPaymentMethod')
					}
				/>
				{!ready && loadingRender}
				{ready && (
					<div className="flex w-full flex-col items-center">
						<div className="flex w-full justify-center p-5">
							<PaymentElement
								mode="update"
								currency={currency || priceCurrency}
								onSuccess={onSavedPaymentMethod}
								onError={handleSetupErr}
							/>
						</div>
					</div>
				)}
			</DialogContent>
		</Dialog>
	);
}

export default UpdatePaymentMethod;
